import { actions as notifications } from '@saucelabs/sl-container-notifications';

import actions from './actions';

const injectImage = (file) => (dispatch, getState) => {
  dispatch(actions.injectImageRequest());

  const previewImageURL = URL.createObjectURL(file);
  const fileName = file.name;

  const device = getState().apps.manual.session.get('device');

  return device.injectImage(file)
    .then((response) => {
      // TODO: Let request errors fail in `web-rdc-client` to enable handling server errors.
      // Right now the response only has a message when the request fails (i.e. 500 status).
      if (response.message) {
        dispatch(notifications.notifyDanger(response.message));
        return dispatch(actions.injectImageFailure());
      }
      dispatch(notifications.notifySuccess('The image has been uploaded successfully.'));

      // any reason why previewImageURL + fileName are sent via meta and not the normal payload?
      return dispatch(actions.injectImageSuccess(null, { previewImageURL, fileName }));
    })
    .catch((error) => {
      dispatch(notifications.notifyDanger(
        `Image could not be uploaded. The file size should be 5 MB or less and the supported formats are JPEG and PNG.\n${error}`,
      ));
      return dispatch(actions.injectImageFailure());
    });
};

export default {
  injectImage,
};
